var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLatePayment = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19081_919)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.8223 19.4414C23.0759 19.1877 23.4875 19.1877 23.7412 19.4414C23.9947 19.695 23.9947 20.1057 23.7412 20.3594L22.9756 21.125L23.7412 21.8906C23.9949 22.1443 23.9949 22.5559 23.7412 22.8096C23.4875 23.0631 23.0759 23.0632 22.8223 22.8096L22.0566 22.0439L21.292 22.8096C21.0384 23.0632 20.6267 23.0631 20.373 22.8096C20.1194 22.5559 20.1194 22.1443 20.373 21.8906L21.1387 21.125L20.373 20.3594C20.1196 20.1057 20.1196 19.695 20.373 19.4414C20.6267 19.1877 21.0383 19.1877 21.292 19.4414L22.0566 20.207L22.8223 19.4414ZM20.6553 9C22.8644 9 24.6553 10.7909 24.6553 13V16.6611C24.6551 17.2133 24.2074 17.6611 23.6553 17.6611H21.7266C19.5176 17.6613 17.7266 19.4521 17.7266 21.6611V21.8574C17.7265 22.4096 17.2788 22.8574 16.7266 22.8574H11.334C9.12491 22.8574 7.33408 21.0665 7.33398 18.8574V13C7.33398 10.7909 9.12485 9 11.334 9H20.6553ZM15.9951 14.1963C15.0386 14.1963 14.2629 14.9713 14.2627 15.9277C14.2627 16.8844 15.0385 17.6602 15.9951 17.6602C16.9516 17.66 17.7266 16.8843 17.7266 15.9277C17.7263 14.9714 16.9515 14.1965 15.9951 14.1963ZM10.7979 11.5977C10.3196 11.5977 9.93176 11.9856 9.93164 12.4639C9.93164 12.9422 10.3195 13.3301 10.7979 13.3301C11.2761 13.33 11.6641 12.9421 11.6641 12.4639C11.6639 11.9857 11.276 11.5978 10.7979 11.5977Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19081_919"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLatePayment);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/late_payment.63f4160dd1092b78fe01f4373dee799b.svg";